import React from 'react';
import '../styles/LegalPages.css';

function DataProtection() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Política de Protección de Datos</h1>
                <p className="last-updated">Última actualización: Diciembre 2024</p>

                <section className="legal-section">
                    <h2>1. Compromiso con la Protección de Datos</h2>
                    <p>
                        En JAMA Delivery, la protección de tus datos personales es una prioridad fundamental.
                        Esta política detalla cómo protegemos, procesamos y gestionamos tu información de acuerdo
                        con las mejores prácticas internacionales y la legislación ecuatoriana vigente,
                        incluyendo la Ley Orgánica de Protección de Datos Personales.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>2. Responsable del Tratamiento de Datos</h2>
                    <p><strong>JAMA Delivery</strong></p>
                    <ul>
                        <li>Domicilio: Ibarra, Ecuador</li>
                        <li>Email: protecciondatos@jama.com</li>
                        <li>Teléfono: +593 XXX XXXX</li>
                    </ul>
                    <p>
                        JAMA Delivery actúa como responsable del tratamiento de tus datos personales y se
                        compromete a garantizar su protección y confidencialidad.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>3. Base Legal para el Procesamiento</h2>
                    <p>Procesamos tus datos personales basándonos en:</p>
                    <ul>
                        <li><strong>Ejecución de contrato:</strong> Para proporcionar nuestros servicios de delivery</li>
                        <li><strong>Consentimiento:</strong> Para marketing y comunicaciones promocionales</li>
                        <li><strong>Interés legítimo:</strong> Para mejorar nuestros servicios y prevenir fraudes</li>
                        <li><strong>Obligación legal:</strong> Para cumplir con requisitos fiscales y legales</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>4. Categorías de Datos Personales</h2>

                    <h3>4.1 Datos de Identificación</h3>
                    <ul>
                        <li>Nombre completo</li>
                        <li>Número de cédula o documento de identidad (si aplica)</li>
                        <li>Fecha de nacimiento</li>
                    </ul>

                    <h3>4.2 Datos de Contacto</h3>
                    <ul>
                        <li>Dirección de correo electrónico</li>
                        <li>Número de teléfono móvil</li>
                        <li>Dirección física de entrega</li>
                    </ul>

                    <h3>4.3 Datos de Transacción</h3>
                    <ul>
                        <li>Historial de pedidos</li>
                        <li>Información de pago (tokenizada y encriptada)</li>
                        <li>Montos de transacciones</li>
                    </ul>

                    <h3>4.4 Datos Técnicos</h3>
                    <ul>
                        <li>Dirección IP</li>
                        <li>Datos de geolocalización</li>
                        <li>Información del dispositivo</li>
                        <li>Cookies e identificadores únicos</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>5. Medidas de Seguridad Implementadas</h2>

                    <h3>5.1 Seguridad Técnica</h3>
                    <ul>
                        <li><strong>Encriptación:</strong> Todos los datos sensibles se transmiten mediante SSL/TLS</li>
                        <li><strong>Tokenización:</strong> Los datos de pago se tokenizan y no se almacenan en texto plano</li>
                        <li><strong>Firewalls:</strong> Protección perimetral mediante firewalls de última generación</li>
                        <li><strong>Autenticación:</strong> Sistemas de autenticación multifactor para accesos administrativos</li>
                        <li><strong>Monitoreo:</strong> Vigilancia continua de actividades sospechosas</li>
                    </ul>

                    <h3>5.2 Seguridad Organizativa</h3>
                    <ul>
                        <li>Acceso restringido basado en el principio de mínimo privilegio</li>
                        <li>Capacitación regular del personal en protección de datos</li>
                        <li>Acuerdos de confidencialidad con todos los empleados</li>
                        <li>Políticas de escritorio limpio y pantalla limpia</li>
                        <li>Procedimientos de respuesta ante incidentes de seguridad</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>6. Transferencia de Datos</h2>

                    <h3>6.1 Transferencias Nacionales</h3>
                    <p>
                        Compartimos datos con terceros dentro de Ecuador solo cuando es necesario para
                        proporcionar nuestros servicios:
                    </p>
                    <ul>
                        <li>Restaurantes asociados (solo información necesaria para el pedido)</li>
                        <li>Repartidores (solo dirección de entrega y contacto)</li>
                        <li>Proveedores de servicios de pago</li>
                    </ul>

                    <h3>6.2 Transferencias Internacionales</h3>
                    <p>
                        En algunos casos, podemos utilizar servicios de proveedores internacionales
                        (como servicios en la nube). En estos casos:
                    </p>
                    <ul>
                        <li>Nos aseguramos de que cumplan con estándares adecuados de protección</li>
                        <li>Implementamos cláusulas contractuales estándar</li>
                        <li>Obtenemos tu consentimiento cuando sea legalmente requerido</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>7. Derechos del Titular de los Datos</h2>
                    <p>Conforme a la legislación ecuatoriana, tienes derecho a:</p>

                    <h3>7.1 Derecho de Acceso</h3>
                    <p>
                        Solicitar confirmación sobre si estamos tratando tus datos y acceder a los mismos.
                    </p>

                    <h3>7.2 Derecho de Rectificación</h3>
                    <p>
                        Corregir datos inexactos o incompletos.
                    </p>

                    <h3>7.3 Derecho de Supresión</h3>
                    <p>
                        Solicitar la eliminación de tus datos cuando ya no sean necesarios o retires tu consentimiento.
                    </p>

                    <h3>7.4 Derecho de Oposición</h3>
                    <p>
                        Oponerte al tratamiento de tus datos para fines específicos.
                    </p>

                    <h3>7.5 Derecho a la Portabilidad</h3>
                    <p>
                        Recibir tus datos en un formato estructurado y de uso común.
                    </p>

                    <h3>7.6 Derecho a Limitar el Tratamiento</h3>
                    <p>
                        Solicitar la limitación del tratamiento en circunstancias específicas.
                    </p>

                    <h3>7.7 Derecho a No Ser Objeto de Decisiones Automatizadas</h3>
                    <p>
                        No ser objeto de decisiones basadas únicamente en tratamiento automatizado que produzcan
                        efectos jurídicos o te afecten significativamente.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>8. Ejercicio de Derechos</h2>
                    <p>
                        Para ejercer cualquiera de tus derechos, puedes:
                    </p>
                    <ul>
                        <li>Enviar un correo a: protecciondatos@jama.com</li>
                        <li>Llamar a: +593 XXX XXXX</li>
                        <li>Visitar nuestra oficina en: Ibarra, Ecuador</li>
                    </ul>
                    <p>
                        <strong>Tiempo de respuesta:</strong> Responderemos a tu solicitud dentro de los 15 días
                        hábiles siguientes a su recepción, conforme a la legislación aplicable.
                    </p>
                    <p>
                        <strong>Documentación requerida:</strong> Para verificar tu identidad, te solicitaremos
                        una copia de tu documento de identificación.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>9. Período de Retención de Datos</h2>
                    <p>
                        Conservamos tus datos personales durante diferentes períodos según su finalidad:
                    </p>
                    <ul>
                        <li><strong>Datos de cuenta activa:</strong> Mientras mantengas tu cuenta activa</li>
                        <li><strong>Datos de transacciones:</strong> 7 años (requisito fiscal)</li>
                        <li><strong>Datos de marketing:</strong> Hasta que retires tu consentimiento</li>
                        <li><strong>Datos de cookies:</strong> Según configuración (generalmente 1-2 años)</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>10. Menores de Edad</h2>
                    <p>
                        Nuestros servicios no están dirigidos a menores de 18 años. No recopilamos
                        intencionalmente información de menores. Si descubrimos que hemos recopilado datos
                        de un menor sin consentimiento parental, eliminaremos esa información inmediatamente.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>11. Notificación de Brechas de Seguridad</h2>
                    <p>
                        En caso de una brecha de seguridad que pueda afectar tus datos personales:
                    </p>
                    <ul>
                        <li>Te notificaremos dentro de las 72 horas de conocer el incidente</li>
                        <li>Informaremos a las autoridades competentes cuando sea legalmente requerido</li>
                        <li>Proporcionaremos información sobre las medidas tomadas</li>
                        <li>Te orientaremos sobre los pasos a seguir para protegerte</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>12. Autoridad de Control</h2>
                    <p>
                        Si consideras que tus derechos de protección de datos han sido vulnerados, tienes derecho
                        a presentar una queja ante la Autoridad de Protección de Datos competente en Ecuador.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>13. Actualizaciones de esta Política</h2>
                    <p>
                        Podemos actualizar esta Política de Protección de Datos periódicamente para reflejar
                        cambios en nuestras prácticas o requisitos legales. Te notificaremos sobre cambios
                        significativos mediante:
                    </p>
                    <ul>
                        <li>Notificación en la aplicación</li>
                        <li>Correo electrónico</li>
                        <li>Aviso destacado en nuestro sitio web</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>14. Contacto del Delegado de Protección de Datos</h2>
                    <p>
                        Para cualquier consulta relacionada con la protección de tus datos personales:
                    </p>
                    <ul>
                        <li><strong>Email:</strong> dpo@jama.com</li>
                        <li><strong>Teléfono:</strong> +593 XXX XXXX</li>
                        <li><strong>Dirección:</strong> Ibarra, Ecuador</li>
                    </ul>
                </section>
            </div>
        </div>
    );
}

export default DataProtection;
